import type {
  IQueryTemplateModel,
  IQueryTemplateStore,
} from '@monorepo/types/document/queryTemplate/queryTemplate.types';
import { tableUpdate } from '@monorepo/utils';
import { localCache } from '@/utils/storageHandler';

const initState: IQueryTemplateStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    keyword: '',
    location_id: localCache.getItem('location_id'),
    offset: 0,
    limit: 50,
  },
};

const QueryTemplateStore: IQueryTemplateModel = {
  namespace: 'queryTemplateStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return { ...state, tableList };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default QueryTemplateStore;
